import React, { useContext } from "react";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { updateNormalisedConfig } from "@store/slices/config";
import { useRouter } from "next/router";
import { Context } from "@components/useContext/context";
import { useOnload } from "@utils/useOnLoad";
// import button from "@widgets/button";
import { FormatCTAtext } from "@components/mmvNotFoundModal";
import { useDispatch, useSelector } from "react-redux";

const HcaptchaPrimaryButton = (props: any) => {
  const { isDesktop } = useContext(Context);
  const dispatch = useDispatch();
  const router = useRouter();
  const { current_node, proposal_ekey } = router.query;
  const {
    proposalMobileNumber,
    label,
    actions,
    styles,
    isModalCta = false
  } = props;
  const { on_click, on_send_otp } = actions || [];

  const { enteredPhone, normalisedConfig, globalPayloadData, field_error } =
    useSelector(({ globalState, configuration }: any) => {
      return {
        enteredPhone: globalState?.payloadData.phone,
        normalisedConfig: configuration?.normalisedConfig,
        globalPayloadData: globalState?.payloadData,
        field_error: globalState?.field_error
      };
    });

  const { on_load } = actions || {};

  useOnload({ on_load });

  const handleClick = async () => {
    if (on_click?.[0] && typeof on_click[0].funCall === "function") {
      const args = on_click[0].args;
      const { required_fields } = args;
      const getData = await on_click[0].funCall({
        requiredFields: required_fields,
        normalisedConfig,
        globalPayloadData
      });

      const { updatedNormalisedConfig, isError } = getData || {};

      dispatch(
        updateNormalisedConfig({
          normalisedConfig: updatedNormalisedConfig
        })
      );

      if (isError || field_error) return;

      if (isModalCta) {
        if (proposalMobileNumber !== enteredPhone) {
          callNextNode();
        } else {
          if (
            on_send_otp?.[1] &&
            typeof on_send_otp[1].funCall === "function"
          ) {
            const { args } = on_send_otp[1];
            on_send_otp[1].funCall(args || {});
          }
        }
      } else {
        callNextNode();
      }
      if (on_click?.[1] && typeof on_click[1].funCall === "function") {
        const { args } = on_click[1];
        on_click[1].funCall(args || {});
      }
    }
  };

  const callNextNode = () => {
    if (on_send_otp?.[0] && typeof on_send_otp[0].funCall === "function") {
      const payload = {
        current_node: current_node,
        data: {
          proposal_ekey: proposal_ekey,
          ...globalPayloadData
        }
      };

      on_send_otp[0].funCall({
        shouldRedirect: true,
        ...payload,
        ...on_send_otp[0].args
      });
    }
  };

  return (
    <div
      style={{
        width: isDesktop ? "200px" : "100%",
        ...styles
      }}
    >
      <PrimaryButton
        onClick={() => {
          handleClick();
        }}
      >
        <FormatCTAtext>{label}</FormatCTAtext>
      </PrimaryButton>
    </div>
  );
};

export default HcaptchaPrimaryButton;
